import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { FiProfileSizes, IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';
import { SharedActionsBaseService } from '@fi-shared/fi-shared-services/shared-actions-base.service';

@Component({
    selector: 'fi-profile-icon-stacked',
    templateUrl: './fi-profile-icon-stacked.component.html',
    styleUrls: ['./fi-profile-icon-stacked.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-profile-icon-stacked' },
})
export class FiProfileIconStackedComponent {
    @Input({ required: true }) profilesData: IUserProfile[] = [];
    @Input() maxProfilesToShow: number;

    protected readonly FiProfileSizes = FiProfileSizes;
    protected readonly FiInfoIconMode = FiInfoIconMode;

    constructor(private sharedActionsService: SharedActionsBaseService) {}

    protected getRemainingProfiles(): IUserProfile[] {
        return this.profilesData.slice(this.maxProfilesToShow);
    }

    protected getProfilesToDisplay(): IUserProfile[] {
        if (!this.profilesData || this.profilesData.length === 0) {
            return [];
        }
        if (this.maxProfilesToShow && this.profilesData.length > this.maxProfilesToShow) {
            return this.profilesData.slice(0, this.maxProfilesToShow);
        }
        return this.profilesData;
    }

    protected getRemainingCount(): number {
        if (!this.maxProfilesToShow || this.profilesData.length <= this.maxProfilesToShow) {
            return 0;
        }
        return this.profilesData.length - this.maxProfilesToShow;
    }

    protected openUserDetails($event: MouseEvent, userId: number): void {
        $event.stopPropagation();
        this.sharedActionsService.openUserViewPopup(userId);
    }
}
